import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { DefaultWidgetsTemplateDTO } from './useDefaultTemplateQuery';
import { setDefaults } from '../util/normalizeWidgets';

interface WidgetTemplateResponse {
  templateId: string;
  name: string;
  configuration: DefaultWidgetsTemplateDTO;
}

interface WidgetTemplateDTO {
  templateId: string;
  name: string;
  widgets: DefaultWidgetsTemplateDTO;
}

const fetchWidgetTemplate = async (templateId: string): Promise<WidgetTemplateDTO> => {
  const response: WidgetTemplateResponse = await authFetch(
    `/Adviser/PersonalFinanceTemplates/GetTemplateById?templateId=${templateId}`,
  );

  return {
    ...response,
    widgets: setDefaults(response.configuration),
  };
};

interface Args {
  templateId: string;
}

export const useWidgetTemplateQuery = ({ templateId }: Args) => {
  return useQuery(queryKeys.widgetTemplate(templateId), () => fetchWidgetTemplate(templateId), {
    enabled: !!templateId,
  });
};
